import { styled } from '@linaria/react';

export const ProfileCardSkeleton = styled.div`
	@keyframes skeleton {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	height: 40rem;
	border-radius: var(--radius-l);

	animation: skeleton 1s infinite alternate;
	background-color: var(--color-grey-10-solid);
`;
